document.addEventListener('DOMContentLoaded', function () {
  const sliderWrapper = document.querySelector('.slider-wrapper');
  const slides = document.querySelectorAll('.slide');
  const indicators = document.querySelectorAll('.indicator');

  let currentIndex = 0; // Índice inicial
  const slideInterval = 5000; // Tiempo entre cambios automáticos

  // Variables para gestionar el deslizamiento
  let startX = 0;
  let endX = 0;

  // Función para actualizar el slider
  function updateSlider(index) {
    sliderWrapper.style.transform = `translateX(-${index * 100}%)`;
    indicators.forEach(indicator => indicator.classList.remove('active'));
    indicators[index].classList.add('active');
  }

  // Función para avanzar al siguiente slide
  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    updateSlider(currentIndex);
  }

  // Función para retroceder al slide anterior
  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSlider(currentIndex);
  }

  // Reinicia el temporizador de cambio automático
  function resetAutoSlide() {
    clearInterval(autoSlideInterval);
    autoSlideInterval = setInterval(nextSlide, slideInterval);
  }

  // Manejo de gestos táctiles (swipe)
  sliderWrapper.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX; // Obtiene la posición inicial del toque
  });

  sliderWrapper.addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].clientX; // Obtiene la posición final del toque
    if (startX - endX > 50) {
      // Swipe hacia la izquierda
      nextSlide();
      resetAutoSlide();
    } else if (endX - startX > 50) {
      // Swipe hacia la derecha
      prevSlide();
      resetAutoSlide();
    }
  });

  // Manejo de clic en las imágenes
  slides.forEach((slide) => {
    const image = slide.querySelector('.slide-image');
    image.addEventListener('click', () => {
      nextSlide();
      resetAutoSlide();
    });
  });

  // Manejo de clic en los indicadores
  indicators.forEach((indicator, index) => {
    indicator.addEventListener('click', () => {
      currentIndex = index;
      updateSlider(currentIndex);
      resetAutoSlide();
    });
  });

  // Inicializa el slider
  updateSlider(currentIndex);

  // Configura el cambio automático
  let autoSlideInterval = setInterval(nextSlide, slideInterval);
});